import { STORE_INFORMATION } from "actions"

export const initialState = {
  latestReleaseVer: 0,
  readReleaseVer: 0,
  isRead: true,
}

export const information = (state = initialState, action) => {
  switch (action.type) {
    case STORE_INFORMATION:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default information
